// src/components/CuePanel.tsx
import React from "react";
import { CueNote } from "../types";
import NoteBody from "./NoteBody";

export default function CuePanel({
  stealth,
  onToggleStealth,
  pinned,
  onTogglePin,
  onPrev,
  onNext,
  activeNote,
  activeIndex,
  preNoteExtras, // e.g., hints shown between controls and content
}: {
  stealth: boolean;
  onToggleStealth: () => void;
  pinned: boolean;
  onTogglePin: () => void;
  onPrev: () => void;
  onNext: () => void;
  activeNote: CueNote | null;
  activeIndex: number;
  preNoteExtras?: React.ReactNode;
}) {
  return (
    <>
      <div className="button-group">
        <button
          className="button button-secondary"
          onClick={onToggleStealth}
          title="Presentation Mode (Ctrl+Alt+S)"
        >
          {stealth ? "Exit Presentation" : "Presentation"}
        </button>

        <button
          className="button button-secondary"
          onClick={onTogglePin}
          title="Pin the current CueBoard"
        >
          {pinned ? "Unpin" : "Pin"}
        </button>

        <button className="button button-secondary" onClick={onPrev}>Previous</button>
        <button className="button button-secondary" onClick={onNext}>Next</button>
      </div>

      {preNoteExtras ? <div style={{ marginBottom: 8 }}>{preNoteExtras}</div> : null}

      {activeNote ? (
        <div>
          <h3 id={`cueboard-title-${activeNote.id}`} className="no-margin-top">
            {`${activeIndex + 1}. ${activeNote.title}`}
          </h3>
          <NoteBody text={activeNote.body_markdown} />
        </div>
      ) : (
        <div className="placeholder-text">
          <p>No cue selected yet. Say a trigger like <em>"tell me about yourself"</em> or use the Trigger Tester.</p>
        </div>
      )}
    </>
  );
}
